<template>
  <MRow :gutter="0" class="mx-4">
    <MCol :lg="12" :sm="12" auto-size>
      <MRow>
        <MCol :size="6">
          <FlotoFormItem
            id="cost-factor-picker"
            :label="`${$tc('cost')} ${$tc('factor')}`"
            rules="required"
          >
            <FlotoDropdownPicker
              v-model="formData.costFactor"
              as-input
              :options="costFactorOptions"
            />
          </FlotoFormItem>
        </MCol>
      </MRow>
      <MRow>
        <MCol :size="6">
          <FlotoFormItem
            id="date-picker"
            :label="$tc('date')"
            rules="required|nonzero"
          >
            <FlotoDatePicker
              v-model="formData.acquireDate"
              :show-time="resource.origin !== 'purchase'"
            />
          </FlotoFormItem>
        </MCol>
        <MCol :size="6">
          <FlotoFormItem
            :label="`${$tc('amount')}`"
            rules="required|nonzero|min_value:1|max_value"
          >
            <MInputGroup compact class="input-group-container mb-2">
              <MInputNumber
                id="amount-input"
                v-model="formData.amount"
                :precision="2"
                type="number"
              />
              <CurrencyPicker
                v-model="formData.currencyId"
                :allow-clear="false"
              />
            </MInputGroup>
          </FlotoFormItem>
        </MCol>
      </MRow>
      <FlotoFormItem
        id="description-input"
        v-model="formData.description"
        :placeholder="$t('description')"
        :label="$t('description')"
        :rows="5"
        type="textarea"
      />
    </MCol>
  </MRow>
</template>

<script>
import CurrencyPicker from '@components/data-picker/currency-picker'
import { costFactorOptions } from '@modules/asset-management/helpers/depreciation'
import { OrganizationComputed } from '@state/modules/organization'
export default {
  name: 'CostForm',
  components: { CurrencyPicker },
  props: {
    formData: { type: Object, required: true },
    resource: { type: Object, required: true },
  },
  data() {
    this.costFactorOptions = costFactorOptions()
    return {}
  },
  computed: {
    ...OrganizationComputed,
  },
}
</script>

<style lang="less" scoped>
.input-group-container {
  top: 3px !important;
  display: flex !important;
  .@{ant-prefix}-input-number {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>

<style lang="less">
.input-group-container {
  .duration-type {
    .@{ant-prefix}-select-selection {
      @apply bg-neutral-lightest text-neutral;
    }
  }
}
</style>
